import { useContext } from "react";
import { ModalSettingContext } from "../../index";
import { conferenceTypesEnum } from "./conferenceTypesEnum";
import s from './index.module.css';
import classNames from "classnames";
import useRoles from "@/hooks/useRoles";
import TooltipWrapper from "@UI/New/TooltipWrapper/TooltipWrapper";

export const ConferenceType = () => {
    const { isAdminOrJuniorAdmin } = useRoles();

    return (
        <div className={s.tabs}>
            <Button tab={conferenceTypesEnum.group} text='Групповой' />
            <Button tab={conferenceTypesEnum.private} text='Индивидуальный' />
            {
               isAdminOrJuniorAdmin && (
                <TooltipWrapper title='В разработке'>
                    <div><Button disabled tab={conferenceTypesEnum.customizable} text='Настраиваемый' /></div>
                </TooltipWrapper>
               ) 
            }
        </div>
    )
}

const Button = ({text, tab, disabled}) => {
    const { state, setFieldInState } = useContext(ModalSettingContext);
    return(
       <button 
            disabled={!!disabled}
            style={{opacity: disabled ? 0.5 : 1}}
            onClick={
                () => {
                    const resetFields = ['childrens', 'groups', 'unavailableStudents', 'customizableValue', 'tariff', 'name'];
                    if(tab === conferenceTypesEnum.customizable || state.customizable === conferenceTypesEnum.customizable) {
                        resetFields.push('direction')
                        resetFields.push('seminariansСlasses')
                        resetFields.push('comment')
                        resetFields.push('comment_dz')
                        resetFields.push('comment_to_dz')
                        resetFields.push('lesson_topic')
                        resetFields.push('speaker_id')
                    }

                    setFieldInState(
                        {
                            field: 'conference_type', 
                            value: tab, 
                            resetFields 
                        }
                    )
                }
            }
            className={
               classNames(
                s.button,
                {[s.buttonActive] : state.conference_type === tab}
               )
            } 
       >
        {text}
       </button>
    )
}